import { FileType } from '@lsq-frontend/remote-services/enterprise/common';

export enum FileExtensions {
    Csv = 'csv'
}

export class FilesHelper {
    public static getExtensionFromFileName(fileName: string): string {
        return fileName.split('.').pop();
    }

    public static getFileType(fileName: string): FileType {
        const extension = FilesHelper.getExtensionFromFileName(fileName);

        switch (extension) {
            case 'csv':
                return FileType.Csv;
            case 'json':
                return FileType.Json;
            case 'pdf':
                return FileType.Pdf;
            case 'tiff':
            case 'tif':
                return FileType.Tif;
            default:
                return FileType.Unknown;
        }
    }
}
